import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getCategoryName, featuredPosts } from "../data/posts";

// --- Background images for featured posts (keyed by post slug) ---
// To add an image: drop the file in src/Aseets/ and add one line below.
import railoneImg from "../Aseets/railone-app.jpg";
import nubiaImg from "../Aseets/nubia-redmagic.jpeg";
import boiImg from "../Aseets/boi-omni.jpg";

const featureImages = {
  "railone-app-download": railoneImg,
  "mobile-nubia-redmagic-launcher": nubiaImg,
  "boi-mobile-omni-neo-bank-app-2-0-0": boiImg,
};

// Build the card background: real image if available, else a colored gradient.
const cardBg = (post) => {
  const img = featureImages[post.slug];
  return img
    ? { backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center" }
    : { background: `linear-gradient(135deg, ${post.color}, ${post.color}cc)` };
};

function FeatureCard({ post, mini }) {
  const title =
    mini && post.title.length > 60 ? post.title.slice(0, 60) + "…" : post.title;
  return (
    <Link to={`/post/${post.slug}`} className={mini ? "" : "d-block h-100"}>
      <div className={`feature-card ${mini ? "feature-mini h-100" : ""}`} style={cardBg(post)}>
        <div className="overlay" />
        <div className="fc-body">
          <span className="fc-cat">{getCategoryName(post.category)}</span>
          <h3 className={mini ? "" : "h4"}>{title}</h3>
          {!mini && (
            <span className="small text-white-50">
              {post.author} · {post.date}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}

// Big lead story on the left, two stacked mini features on the right.
function FeaturedSlider() {
  const [lead, ...rest] = featuredPosts;
  if (!lead) return null;

  return (
    <Row className="g-3 mb-4">
      <Col lg={7}>
        <FeatureCard post={lead} />
      </Col>
      <Col lg={5}>
        <Row className="g-3 h-100">
          {rest.slice(0, 2).map((p) => (
            <Col xs={12} key={p.id}>
              <FeatureCard post={p} mini />
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
}

export default FeaturedSlider;
